import { UserModel, ActiveDirectoryUserModel, UpdateUserCommand, CreateUserCommand } from '@core/services/api.service';

export class LoadUserAction {
  static readonly type = '[Users] Load User';

  constructor(public payload: { userId: string }) { }
}

export class LoadUserSuccessAction {
  static readonly type = '[Users] Load User Success';

  constructor(public payload: { user: UserModel }) { }
}

export class LoadUserFailAction {
  static readonly type = '[Users] Load User Fail';
}

export class LoadUsersAction {
  static readonly type = '[Users] Load Users';
}

export class LoadUsersSuccessAction {
  static readonly type = '[Users] Load Users Success';

  constructor(public payload: { users: UserModel[] }) { }
}

export class LoadUsersFailAction {
  static readonly type = '[Users] Load Users Fail';
}

export class LoadAdUsersAction {
  static readonly type = '[Users] Load Ad Users';

  constructor(public payload: { searchTerm: string }) { }
}

export class LoadAdUsersSuccessAction {
  static readonly type = '[Users] Load Ad Users Success';

  constructor(public payload: { adUsers: ActiveDirectoryUserModel[] }) { }
}

export class LoadAdUsersFailAction {
  static readonly type = '[Users] Load Ad Users Fail';
}

export class LoadUsersWithRolesAction {
  static readonly type = '[Users] Load Users With Roles';
}

export class LoadUsersWithRolesSuccessAction {
  static readonly type = '[Users] Load Users With Roles Success';

  constructor(public payload: { users: UserModel[] }) { }
}

export class LoadUsersWithRolesFailAction {
  static readonly type = '[Users] Load Users With Roles Fail';
}

export class UpdateUserAction {
  static readonly type = '[Users] Update User';

  constructor(public payload: { updateUserCommand: UpdateUserCommand }) { }
}

export class UpdateUserSuccessAction {
  static readonly type = '[Users] Update User Success';

  constructor(public payload: { user: UserModel }) { }
}

export class UpdateUserFailAction {
  static readonly type = '[Users] Update User Fail';
}

export class ToggleIsActiveUserAction {
  static readonly type = '[Users] Toggle Is Active User Action';

  constructor(public payload: { user: UserModel }) { }
}

export class ToggleIsActiveUserSuccessAction {
  static readonly type = '[Users] Toggle Is Active User Success';

  constructor(public payload: { user: UserModel }) { }
}

export class ToggleIsActiveUserFailAction {
  static readonly type = '[Users] Toggle Is Active User Fail';

  constructor(public payload: { user: UserModel }) { }
}

export class RegisterUserAction {
  static readonly type = '[Users] Create User';

  constructor(public payload: { createUserCommand: CreateUserCommand }) { }
}

export class RegisterUserSuccessAction {
  static readonly type = '[Users] Create User Success';

  constructor(public payload: { user: UserModel }) { }
}

export class RegisterUserFailAction {
  static readonly type = '[Users] Create User Fail';
}

export class RegisterSignalRHandlersForUsersAction {
  static readonly type = '[Users] Register SignalR Handlers For Users';
}

export class ToggleUserConnectionStatusAction {
  static readonly type = '[Users] Toggle User Connection Status';

  constructor(public payload: { username: string, connected: boolean }) { }
}
